import * as React from "react";
import { Edit } from "react-admin";
import { PartnersCreateForm } from "./PartnersCreate";

export const PartnersEdit = () => (
  <Edit>
    <PartnersCreateForm />
  </Edit>
);
